import {
  changeCampaignLines,
  toggleCampaignLineExpansion,
} from '../../actions';
import { connectEditor } from '../../connect-editor';
import {
  getLinesForBusiness,
  getLinesForProduct,
  isSelectable,
  isSelected,
} from '../../utils';
import CampaignLineHeaderActions from './CampaignLineHeaderActions';

const mapStateToProps = (
  { campaignLinesById },
  { products, countries, isProduct, isDraftCampaignEnabled },
) => {
  const lines = isProduct
    ? getLinesForProduct({ countries }, campaignLinesById)
    : getLinesForBusiness({ products }, campaignLinesById);

  const editableLines = lines.filter(line =>
    isSelectable(line, isDraftCampaignEnabled),
  );
  const disableSelection = editableLines.length < 1;
  return {
    editableLines,
    disableSelection,
    selected: disableSelection ? false : editableLines.every(isSelected),
  };
};

const mapDispatchToProps = {
  toggleCampaignLineExpansion,
  changeCampaignLines,
};

const mergeProps = (stateProps, dispatchProps, ownProps) => {
  const { label, expanded } = ownProps;
  const { editableLines, selected, ...restStateProps } = stateProps;
  return {
    ...ownProps,
    selected,
    ...restStateProps,
    onToggleExpansion: () => {
      dispatchProps.toggleCampaignLineExpansion(label, !expanded);
    },
    onToggleSelection: () =>
      dispatchProps.changeCampaignLines(
        editableLines.map(({ id }) => id),
        'selected',
        !selected,
      ),
  };
};

export default connectEditor(
  mapStateToProps,
  mapDispatchToProps,
  mergeProps,
)(CampaignLineHeaderActions);
